import * as Sentry from '@sentry/react'

import { hasPGAnalyticsAccess, hasPgComparisonIndicator } from '../../../../van-shared/utils/utils'
import { isNetworkError } from '../../../../van-shared/utils/isNetworkError'
import { resolveLocationScope } from '../../../../van-shared/utils/locationScope'

const STOCK_REPORT_RATE = 'stock-report-rate'

const toDateOnly = date => new Date(date).toISOString().slice(0, 10)

export const buildSummaryParams = ({ locationId, overview }) => {
  const scope = resolveLocationScope(locationId)
  const period = overview.periods && overview.periods.current

  if (Object.keys(scope).length === 0 || !period) {
    return null
  }

  return {
    fromDate: toDateOnly(period.effectiveStartDate),
    toDate: toDateOnly(period.effectiveEndDate),
    programs: [overview.id],
    ...scope
  }
}

// Fetches Postgres stock report rate. Returns null on failure to allow offline fallback
export const fetchStockReportRateProgress = async ({ api, config, user, locationId, overview }) => {
  if (!hasPGAnalyticsAccess(config, user) || !hasPgComparisonIndicator(config, STOCK_REPORT_RATE)) {
    return null
  }

  const params = buildSummaryParams({ locationId, overview })
  if (!params) {
    return null
  }

  let summary
  try {
    summary = await api.analytics.fetchStockReportRateSummary(params)
  } catch (error) {
    if (!isNetworkError(error)) {
      Sentry.captureException(error, {
        extra: {
          locationId,
          programId: overview.id,
          fromDate: params.fromDate,
          toDate: params.toDate
        }
      })
    }
    return null
  }

  return { complete: summary.completedLocations, total: summary.expectedLocations }
}
